import React from "react";
import { useAdminOrderStore } from "../../../../store/useAdminOrderStore.ts";

const AdminRenderReviewButton = ({
      review,
      entityType,
      shipmentId,
      shipmentItemId,
      orderId,
      info
    }) => {
  const openViewReview = useAdminOrderStore((s) => s.openViewReview);

  if (!review?.has_review) return null;

  const handleClick = () => {
    openViewReview(
      {
        entityType,
        shipmentId,
        shipmentItemId,
        orderId,
        info
      },
      review
    );
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="px-3 py-1 text-xs bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
    >
      مشاهده نظر
    </button>
  );
};

export default AdminRenderReviewButton;
